module.exports = __webpack_public_path__ + "static/media/flag-zu.15839d2c.webp";